import styled from 'styled-components';

export const Wrapper = styled.section`
  display: grid;
  grid-template-columns: repeat(5, minmax(0, 1fr));
  max-width: var(--maxWidth);
  margin: -36px auto 0;
  padding: 0 var(--gutter);
  position: relative;

  @media (max-width: 960px) {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
`;

export const Stat = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
  padding: 24px;
  background: var(--surface);
  border: 1px solid var(--line);
  margin: 0 -1px -1px 0;
  animation: fadeUp 0.6s 0.2s var(--ease) both;

  &:first-child {
    border-radius: var(--radius) 0 0 var(--radius);
  }

  &:last-child {
    border-radius: 0 var(--radius) var(--radius) 0;
  }

  span {
    font-family: var(--font-mono);
    font-size: 11px;
    letter-spacing: 0.12em;
    text-transform: uppercase;
    color: var(--muted);
  }

  strong {
    font-family: var(--font-display);
    font-size: clamp(22px, 2.4vw, 30px);
    font-weight: 600;
    letter-spacing: -0.02em;
    color: ${({ $tone }) =>
      $tone === 'up' ? '#2f8a53' : $tone === 'down' ? 'var(--accent)' : 'var(--ink)'};
  }

  small {
    font-size: 13px;
    color: var(--ink-2);
  }

  @media (max-width: 960px) {
    &:first-child {
      border-radius: var(--radius) 0 0 0;
    }
    &:nth-child(2) {
      border-radius: 0 var(--radius) 0 0;
    }
    &:last-child {
      grid-column: 1 / -1;
      border-radius: 0 0 var(--radius) var(--radius);
    }
  }
`;
